<template>
  <img v-if="slug === 'timer'" src="@/images/tool_icons/timer.png" :alt="slug" />

  <img v-else-if="slug === 'stopwatch'" src="@/images/tool_icons/stopwatch.png" :alt="slug" />
</template>

<script setup lang="ts">
  defineProps<{
    slug: string
  }>()
</script>
